import React, { useState, useCallback } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import Cropper from 'react-easy-crop';

const MAX_WIDTH = 512;
const MAX_HEIGHT = 512;
const MAX_FILE_SIZE = 10 * 1024;

function getCroppedImageFile(imageSrc, cropPixels, fileName) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = imageSrc;

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      const scale = Math.min(MAX_WIDTH / cropPixels.width, MAX_HEIGHT / cropPixels.height, 1);
      const width = cropPixels.width * scale;
      const height = cropPixels.height * scale;

      canvas.width = width;
      canvas.height = height;

      ctx.drawImage(
        img,
        cropPixels.x,
        cropPixels.y,
        cropPixels.width,
        cropPixels.height,
        0,
        0,
        width,
        height
      );

      const compress = (quality) => {
        canvas.toBlob((blob) => {
          if (!blob) return reject(new Error('Canvas failed'));

          if (blob.size <= MAX_FILE_SIZE || quality <= 0.3) {
            const file = new File([blob], fileName, {
              type: 'image/jpeg',
              lastModified: Date.now(),
            });
            resolve(file);
          } else {
            compress(quality - 0.1);
          }
        }, 'image/jpeg', quality);
      };

      compress(0.9);
    };

    img.onerror = reject;
  });
}

export default function ResizeAvatar({ isOpen, toggle, imageSrc, onCropped }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [croppedPixels, setCroppedPixels] = useState(null);

  const onCropComplete = useCallback((_, pixels) => {
    setCroppedPixels(pixels);
  }, []);

  const handleCrop = async () => {
    try {
      const file = await getCroppedImageFile(imageSrc, croppedPixels, 'cropped.jpg');
      onCropped(file);
      toggle();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md">
      <ModalHeader toggle={toggle}>Resize Image</ModalHeader>
      <ModalBody>
        <div style={{ position: 'relative', width: '100%', height: 400 }}>
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={1} 
            showGrid={false}
            aspect={2 / 2}
            onCropChange={setCrop}
            onCropComplete={onCropComplete}
            restrictPosition={false}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Cancel</Button>
        <Button color="primary" onClick={handleCrop}>Resize & Save</Button>
      </ModalFooter>
    </Modal>
  );
}